import request from '../request'

//获取关于我们
export function About_post() {
  return request({ url: '/api/AdbotDetail/getInfo',method: 'post'})
}


// WEBPACK FOOTER //
// ./src/api/gw/aboutus.js